import StoreCategoriesModule from './StoreCategories.module';

export default StoreCategoriesModule;
